

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CrossIcon extends Vue {
  @Prop({ default: 'close' }) private readonly testId: string | undefined;
  @Prop({ type: String, default: '#000000' }) private readonly color!: string;
}
